module.exports = fox._r("images/default/gift-87.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/default/gift-87.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/default/gift-87.png
// module id = 288
// module chunks = 4